import {  GeneralButtonStyled, PopTextStyled, PopTextCloseStyled, CategoryHeaderStyled, ItemContainerStyled, ItemEnglishTitleStyled, ItemImageContainerStyled, PriceContainerStyled, ItemEnglishDescriptionStyled, CategoryContainerStyled, ArabicContainerStyled, ItemArabicTitleStyled, ItemArabicDescriptionStyled, FillerContainerStyled, ItemButtonsContainerStyled, ItemButtonStyled, ClosePopUpStyled, ClosePopButtonStyled, AddOnFlexBoxStyled, ArabicAddOnTextStyled } from "../CommonStyled";
import {useState, useEffect} from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan, faPenToSquare, faXmark, faEyeSlash, faEye } from "@fortawesome/free-solid-svg-icons"
import {Link, useLocation, useNavigate} from "react-router-dom";
import axios from "axios"
import { Button } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import styled from "styled-components";



function BreakfastPudding({breakfastPudding, showHiddenItems, auth}) {
    
  
    //const url = "https://www.lovelysunnydayapi.com/api/v1/testMenus";
    const url = process.env.NODE_ENV == "development" ? process.env.REACT_APP_API_URL_DEV : process.env.REACT_APP_API_URL_PROD;

    const [popUpOpen, setPopUpOpen] = useState(false);
    const [itemID, setItemID] = useState("");
    const [itemDelete, setItemDelete] = useState("");

    const[triggerToolTip, setTriggerToolTip] = useState({
        editTool: false,
        deleteTool: false,
        hideTool: false,
    });

  
    
    //function to trigger the pop up screen of the corresponding item
    function handleItemPopUp(_id, itemName) {
        //opens the pop up
        setPopUpOpen(true);
        setItemDelete(itemName)
        //set id here
        setItemID(_id)
    }

    //function to close pop up screen
    function handleClosePopUp() {
        setPopUpOpen(false);
    }

    //function to toggle the tooltips on hover
    function handleToolTip(visible, tooltip) {
        switch (tooltip) {
            case "delete":
                setTriggerToolTip(prevState => ({
                    ...prevState,
                    deleteTool: visible? "true" : false
                }))
            break;

            case "edit":
                setTriggerToolTip(prevState => ({
                    ...prevState,
                    editTool:visible? "true" : false
                }))
            break;

            case "hide":
                setTriggerToolTip(prevState => ({
                    ...prevState,
                    hideTool: visible? "true" : false
                }))
            break;
        }
    }
    
    //updates the hide field of the item in the database
    async function handleHideItem(item_id, show, ) {
        //tomorrow look how we can fix hide or show item
        const link = `${url}/testMenus/${item_id}`
        const item_to_change = breakfastPudding.find(item => item._id === item_id)
        //console.log("the item we want to change is: ", item_to_change);
        //console.log("show is: ", show);
        // console.log("the item to change is: ", item_to_change);
        item_to_change.old_image = item_to_change.image;
        item_to_change.hide = show;
        const itemData = new FormData();
        const imageFile  = item_to_change.image;
        itemData.append('file', imageFile)

        for (const key in item_to_change) {
            if(item_to_change.hasOwnProperty(key) && key !== 'image') {
                if(Array.isArray(item_to_change[key])) {
                    itemData.append(key, JSON.stringify(item_to_change[key]))
                } else {
                    itemData.append(key, item_to_change[key]);
                }
            }
        }

                   for (let pair of itemData.entries()) {
            console.log(pair[0] + ': ' + pair[1] + `the type is: ${typeof(pair[1])}`);
        }
        
        //call the api request for updating the item to hide the image
          const response = await axios.patch(link, itemData, {
              headers: {
              },
              withCredentials: true
          })
    }

    //this function will delete an item when a user clicks on the delete button
    async function handleDeleteItem() {
        const link = `${url}/testMenus/${itemID}`
        const response = await axios.delete(link, {
            withCredentials: true,
        })
        console.log("item deleted successfully", response.data) //maybe add a pop up or something
        setPopUpOpen(false);
    }

    return (
        <>
            {popUpOpen && <ClosePopUpStyled>
                    Are you sure you want to delete {itemDelete}?
                    <ThemeProvider theme = {GeneralButtonStyled}>
                        <Button
                            variant = "contained"
                            color = "primary"
                            onClick = {handleDeleteItem}
                        >
                            YES
                        </Button>
                    </ThemeProvider>
                    <ClosePopButtonStyled 
                        onClick = {handleClosePopUp}
                        onMouseEnter={() => handleToolTip(true, "close")}
                        onMouseLeave={() => handleToolTip(false, "close")}
                    >
                        <FontAwesomeIcon icon = {faXmark} style = {{fontSize: "20px", padding: "0"}}>
                        </FontAwesomeIcon>
                    </ClosePopButtonStyled>
            </ClosePopUpStyled>}
            {!showHiddenItems && <CategoryContainerStyled>
                {
                    breakfastPudding.map(({_id, name_en, name_ar, description_en, description_ar, price, image, add_ons, hide}) => {
                        return (
                            !hide && <ItemContainerStyled>
                                {auth.role === "le-bleu" && <ItemButtonsContainerStyled>
                                <ItemButtonStyled
                                        onMouseEnter = {() => handleToolTip(true, "hide")}
                                        onMouseLeave = {() => handleToolTip(false, "hide")}
                                        onClick = {() => handleHideItem(_id, true)}
                                    >
                                        {triggerToolTip.hideTool && <PopTextStyled  className = "animate__animated animate__fadeInUp animate__faster">hide</PopTextStyled>}
                                        <FontAwesomeIcon icon = {faEyeSlash} style = {{fontSize: "20px", padding: "0"}}/>
                                    </ItemButtonStyled>
                                    <ItemButtonStyled
                                        onMouseEnter = {() => handleToolTip(true, "edit")}
                                        onMouseLeave = {() => handleToolTip(false, "edit")}
                                    >
                                        {triggerToolTip.editTool && <PopTextStyled  className = "animate__animated animate__fadeInUp animate__faster">edit</PopTextStyled>}
                                        <Link to = {`/restaurants/menus/le-bleu/admin/edit-item/${_id}`} target = "_blank">
                                            <FontAwesomeIcon icon = {faPenToSquare} style = {{fontSize: "20px", padding: "0"}}/>
                                        </Link>
                                    </ItemButtonStyled>
                                    <ItemButtonStyled 
                                        onClick = {() => handleItemPopUp(_id, name_en)}
                                        onMouseEnter = {() => handleToolTip(true, "delete")}
                                        onMouseLeave = {() => handleToolTip(false, "delete")}
                                    >
                                        {triggerToolTip.deleteTool && <PopTextStyled className = "animate__animated animate__fadeInUp animate__faster" >delete</PopTextStyled>}
                                        <FontAwesomeIcon icon = {faTrashCan}  style = {{fontSize: "20px", padding: "0px"}}/>
                                    </ItemButtonStyled>
                                </ItemButtonsContainerStyled>}
                                <ItemImageContainerStyled>
                                    <img src = {image} alt = {name_en} />
                                </ItemImageContainerStyled>
                                <ItemEnglishTitleStyled>
                                    {name_en}
                                    <PriceContainerStyled>
                                    {price}
                                    <span>QR</span>
                                </PriceContainerStyled>
                                </ItemEnglishTitleStyled>
                                <ItemEnglishDescriptionStyled>
                                    {description_en}
                                    
                                    {add_ons.length != 0 && <AddOnFlexBoxStyled>
                                        Add: 
                                        {add_ons.map(({name_en, price}) => {
                                            return (
                                                <div>{name_en} / {price} QR •</div>
                                            )
                                        })}
                                    </AddOnFlexBoxStyled>}
                                </ItemEnglishDescriptionStyled>
                                <ArabicContainerStyled>
                                    <ItemArabicTitleStyled>
                                        {name_ar}
                                    </ItemArabicTitleStyled>
                                    <ItemArabicDescriptionStyled>
                                        {description_ar}
                                        {add_ons.length != 0 && <AddOnFlexBoxStyled>
                                          
                                        {add_ons.map(({name_ar, price}) => {
                                            return (
                                                <ArabicAddOnTextStyled>{name_ar} / {price} ر.ق • </ArabicAddOnTextStyled>
                                            )
                                        })}
                                          :اضافة
                                    </AddOnFlexBoxStyled>}
                                    
                                    </ItemArabicDescriptionStyled>
                                </ArabicContainerStyled>
                                <FillerContainerStyled/>
                            </ItemContainerStyled>
                        )
                    })
                }
            </CategoryContainerStyled>}
            {showHiddenItems && <CategoryContainerStyled>
                {
                    breakfastPudding.map(({_id, name_en, name_ar, description_en, description_ar, price, image, add_ons, hide}) => {
                        return (
                            hide && <ItemContainerStyled>
                                {auth.role === "le-bleu" && <ItemButtonsContainerStyled>
                                <ItemButtonStyled
                                        onMouseEnter = {() => handleToolTip(true, "hide")}
                                        onMouseLeave = {() => handleToolTip(false, "hide")}
                                        onClick = {() => handleHideItem(_id, false)}
                                    >
                                        {triggerToolTip.hideTool && <PopTextStyled  className = "animate__animated animate__fadeInUp animate__faster">recover</PopTextStyled>}
                                        <FontAwesomeIcon icon = {faEye} style = {{fontSize: "20px", padding: "0"}}/>
                                    </ItemButtonStyled>
                                    <ItemButtonStyled
                                        onMouseEnter = {() => handleToolTip(true, "edit")}
                                        onMouseLeave = {() => handleToolTip(false, "edit")}
                                    >
                                        {triggerToolTip.editTool && <PopTextStyled  className = "animate__animated animate__fadeInUp animate__faster">edit</PopTextStyled>}
                                        <Link to = {`/restaurants/menus/le-bleu/admin/edit-item/${_id}`} target = "_blank">
                                            <FontAwesomeIcon icon = {faPenToSquare} style = {{fontSize: "20px", padding: "0"}}/>
                                        </Link>
                                    </ItemButtonStyled>
                                    <ItemButtonStyled 
                                        onClick = {() => handleItemPopUp(_id)}
                                        onMouseEnter = {() => handleToolTip(true, "delete")}
                                        onMouseLeave = {() => handleToolTip(false, "delete")}
                                    >
                                        {triggerToolTip.deleteTool && <PopTextStyled className = "animate__animated animate__fadeInUp animate__faster" >delete</PopTextStyled>}
                                        <FontAwesomeIcon icon = {faTrashCan}  style = {{fontSize: "20px", padding: "0px"}}/>
                                    </ItemButtonStyled>
                                </ItemButtonsContainerStyled>}
                                <ItemImageContainerStyled>
                                    <img src = {image} alt = {name_en} />
                                </ItemImageContainerStyled>
                                <ItemEnglishTitleStyled>
                                    {name_en}
                                    <PriceContainerStyled>
                                    {price}
                                    <span>QR</span>
                                </PriceContainerStyled>
                                </ItemEnglishTitleStyled>
                                <ItemEnglishDescriptionStyled>
                                    {description_en}
                                    
                                    {add_ons.length != 0 && <AddOnFlexBoxStyled>
                                        Add: 
                                        {add_ons.map(({name_en, price}) => {
                                            return (
                                                <div>{name_en} / {price} QR •</div>
                                            )
                                        })}
                                    </AddOnFlexBoxStyled>}
                                </ItemEnglishDescriptionStyled>
                                <ArabicContainerStyled>
                                    <ItemArabicTitleStyled>
                                        {name_ar}
                                    </ItemArabicTitleStyled>
                                    <ItemArabicDescriptionStyled>
                                        {description_ar}
                                        {add_ons.length != 0 && <AddOnFlexBoxStyled>
                                          
                                        {add_ons.map(({name_ar, price}) => {
                                            return (
                                                <ArabicAddOnTextStyled>{name_ar} / {price} ر.ق • </ArabicAddOnTextStyled>
                                            )
                                        })}
                                          :اضافة
                                    </AddOnFlexBoxStyled>}
                                    
                                    </ItemArabicDescriptionStyled>
                                </ArabicContainerStyled>
                                <FillerContainerStyled/>
                            </ItemContainerStyled>
                        )
                    })
                }
            </CategoryContainerStyled>}
        </>
    )
}


export default BreakfastPudding;